import script from "./CatalogMainScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogMainScreen.vue?vue&type=script&setup=true&lang=js"

import "./CatalogMainScreen.vue?vue&type=style&index=0&id=2f207b8c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f207b8c"]])

export default __exports__